// extracted by css-extract-rspack-plugin
export default {"UpsellCardComponent":"sAkcM","MainStack":"iQxiq","Large":"ZMViY","Default":"wcbw7","Title":"SpCXb"};